import React from "react";
import { useNavigate } from "react-router-dom";

const NaboraCoupons = ({ data }) => {
  const navigate = useNavigate();

  const defaultData = {
    title: "Nabora Local Coupons",
    subtitle:
      "Unlock neighbourhood offers, merchant discounts and community rewards.",

    coupons: [
      {
        icon: "🥗",
        title: "Food Partner Coupon",
        merchant: "Local Food Merchants",
        offer: "20% OFF",
        validity: "Valid During Exhibition",
        type: "merchant",
      },
      {
        icon: "👗",
        title: "Fashion Festival Coupon",
        merchant: "Local Lifestyle Brands",
        offer: "Special Member Pricing",
        validity: "Limited Period",
        type: "merchant",
      },
      {
        icon: "💜",
        title: "BOS Reward Coupon",
        merchant: "PurpleDoor Ecosystem",
        offer: "Redeem Reward Points",
        validity: "Based On Streaks",
        type: "reward",
      },
    ],
  };

  const content = data || defaultData;

  const handleCouponAction = (coupon) => {
    switch (coupon.type) {
      case "merchant":
        navigate("/finditlocal");
        break;

      case "reward":
        navigate("/purpledoor/bos-rewards");
        break;

      default:
        break;
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="py-8 px-6 bg-gradient-to-br from-violet-950 via-purple-950 to-slate-950">
        <div className="max-w-5xl mx-auto text-center">
          <div className="uppercase tracking-[4px] text-yellow-300 text-sm mb-4">
            🎟️ NABORA COUPONS
          </div>

          <h1 className="text-2xl lg:text-4xl font-bold mb-4">
            {content.title}
          </h1>

          <p className="text-slate-300 text-base lg:text-xl max-w-3xl mx-auto">
            {content.subtitle}
          </p>
        </div>
      </div>

      <div className="py-8 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {content.coupons.map((coupon, index) => (
              <div
                key={index}
                className="bg-slate-900/80 rounded-3xl p-6 border border-white/10 hover:border-purple-400/50 transition-all"
              >
                <div className="text-5xl mb-4">{coupon.icon}</div>

                <h2 className="text-cyan-200 text-lg font-bold mb-3">{coupon.title}</h2>

                <div className="space-y-2 text-sm text-slate-300">
                  <div>🏪 {coupon.merchant}</div>

                  <div className="text-yellow-300 font-semibold">
                    🎯 {coupon.offer}
                  </div>

                  <div>⏳ {coupon.validity}</div>
                </div>

                <button
                  onClick={() => handleCouponAction(coupon)}
                  className="mt-5 w-full px-4 py-2 rounded-xl bg-gradient-to-r from-fuchsia-500 to-violet-600 font-semibold hover:scale-105 transition-all"
                >
                  Use Coupon →
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-8 px-6 bg-gradient-to-br from-slate-900 to-violet-950">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-5xl mb-4">💜</div>

          <h2 className="text-cyan-200 text-xl lg:text-3xl font-bold mb-3">
            Rewards For Supporting Local Businesses
          </h2>

          <p className="text-slate-300 mb-6">
            Nabora combines local commerce with behavioural rewards to create
            repeat customer relationships.
          </p>

          <button
            onClick={() => navigate("/nabora/deals")}
            className="px-6 py-3 rounded-xl border border-white/30 hover:bg-white/10 transition-all"
          >
            ⭐ Explore More Deals
          </button>
        </div>
      </div>
    </div>
  );
};

export default NaboraCoupons;
